<template>
  <div class="swiper" id="mySwiper">
    <div class="swiper-wrapper">
      <div class="swiper-slide" v-for="(item, index) in slides" :key="index">
        <img :src="item" alt="Slide" />
      </div>
    </div>
    <!-- 导航按钮 -->
    <div class="swiper-button-next"></div>
    <div class="swiper-button-prev"></div>
    <!-- 分页器 -->
    <div class="swiper-pagination"></div>
  </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
// 直接从 swiper 引入 Swiper 及所需模块
import Swiper, { Navigation, Pagination, Autoplay } from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

// 轮播图的图片数组，可替换为实际图片链接
const slides = ref([
// require('@/assets/images/swiper1.jpg'),
// require('@/assets/images/swiper2.jpg'),
// require('@/assets/images/swiper3.jpg')
// require('@/assets/images/notice.jpg'),
require('@/assets/images/pcswiper1.jpg'),
require('@/assets/images/pcswiper2.jpg'),
require('@/assets/images/pcswiper3.jpg')
]);

onMounted(() => {
  new Swiper('#mySwiper', {
    modules: [Navigation, Pagination, Autoplay], // 引入 Autoplay 模块
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev'
    },
    pagination: {
      el: '.swiper-pagination',
      clickable: false
    },
    autoplay: {
      delay: 2000, // 自动播放的间隔时间，单位为毫秒，这里设置为 3 秒
      disableOnInteraction: false // 用户操作（如点击导航按钮、分页器等）后是否停止自动播放，设置为 false 表示不停止
    }
  });
});
</script>

<style scoped>
.swiper {
  width: 100%;
}

.swiper-slide img {
  display: block;
  width: 100%;
  object-fit: contain ;
  border:solid 1px #bfd4e9;
}
.swiper-pagination {
    bottom: -2px; 
}
.swiper-button-prev,
.swiper-button-next {
    display: none;
}
</style>